import { environment } from 'src/environments/environment';
import { Serializable } from './serializable.class';

export enum SAP_CONDITION_TYPE {
  CHARGE = 'ZCP0',
  DISCOUNT = 'ZCD2',
}

export interface SapInvoiceItemCondition {
  ConditionType: SAP_CONDITION_TYPE;
  ConditionRate: string;
  PriceUnit?: string;
  UnitPrice?: string;
}

export class SapInvoiceItem extends Serializable {
  public getResourceName(): string {
    return 'billing-reports/gd-billing-dashboard/invoices-items';
  }
  public getApiHost(): string {
    return environment.billingReportsBaseUrl;
  }

  ItemNumber: string;
  SAPMaterialNumber: string;
  MaterialDescription: string;
  MaterialSalesText: string;
  WBSElement: string;
  PurchaseOrderNumber: string;
  PurchaseOrderDate: string;
  BillingDate: string;
  OrderQuantity: string;
  UnitOfMeasure: string;
  CurrencyISO: string;
  Amount: string;
  TaxRate: string;
  TaxAmount: string;
  id: string;
  accountName: string;
  commercialReferenceName: string;
  CustomerNumber: string;
  month: number;
  year: number;
  ProfileGroup: string;
  LineItem: string;
  MaterialGroup1: string;
  MaterialGroup2: string;
  MaterialGroup3: string;
  MaterialGroup4: string;
  BillableItemType: string;
  CostType: string;
  Conditions: SapInvoiceItemCondition[];
}
